import { EventListeners, MinzeElement, Reactive, Attrs } from 'minze'

export interface LvcContributorsAddBlock {
  title: string
  placeholder: string
  open: boolean
  onChange: string
  defaultValue: any
  value: string
}

export class LvcContributorsAddBlock extends MinzeElement {
  attrs: Attrs = []

  reactive: Reactive = [['value', '']]

  async onBlur(e: Event): Promise<void> {
    this.open = false
    this.rerender()
  }

  async onReady() {}

  html = () => {
    return `
  
    <lvc-box padding="24px" background="#ffff" borderRadius="8px" border="1px solid #1E007D4D">
            <lvc-contributors-search-field></lvc-contributors-search-field>
        <lvc-box display="flex" columnGap="16px" mt="8px">
            <lvc-contributor-type-field></lvc-contributor-type-field>
            <lvc-contribution-type-field></lvc-contribution-type-field>
        </lvc-box>
  
    </lvc-box>
    `
  }

  css = () => {
    return `
      :host {

      }


    `
  }

  eventListeners: EventListeners = [[this, 'blur', this.onBlur.bind(this)]]
}
